import { AxiosResponse } from "axios";
import { PrepStation } from "@snackpass/snackpass-types";

import { ErrorWithCause } from "src/utils/errors";

import { client } from "../../client";

export type DittoStation = PrepStation & { ticketCompletionAuthority: boolean };

export class Stations {
    static async getStations(
        storeId: string,
    ): Promise<AxiosResponse<{ prepStations: Array<DittoStation> }>> {
        return client.get(`/d/stations?storeId=${storeId}`).catch((cause) => {
            throw new ErrorWithCause(
                `api.ditto.Stations.getStations: GET to /d/stations?storeId=${storeId} failed`,
                cause,
            );
        });
    }

    static async updateStation(
        prepStationId: string,
        data: DittoStation,
    ): Promise<{ data: { prepStation: DittoStation } }> {
        return client
            .patch(`/d/stations/${prepStationId}`, {
                ...data,
            })
            .catch((cause) => {
                throw new ErrorWithCause(
                    `api.ditto.Stations.updateStation: PATCH to /d/stations/${prepStationId} failed`,
                    cause,
                );
            });
    }

    static async createStation(
        data: DittoStation,
    ): Promise<AxiosResponse<{ prepStation: DittoStation }>> {
        return client
            .post("/d/stations", {
                ...data,
            })
            .catch((cause) => {
                throw new ErrorWithCause(
                    `api.ditto.Stations.createStation: POST to /d/stations failed`,
                    cause,
                );
            });
    }

    static async deleteStation(
        prepStationId: string,
        storeId: string,
    ): Promise<AxiosResponse<null>> {
        return client
            .delete(`/d/stations/${prepStationId}?storeId=${storeId}`)
            .catch((cause) => {
                throw new ErrorWithCause(
                    `api.ditto.Stations.deleteStation: DELETE to /d/stations/${prepStationId} failed`,
                    cause,
                );
            });
    }
}
